import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navigation from './components/Navigation';
import { initializeApiErrorHandlers } from './utils/api';

// Pages
import HomePage from './pages/HomePage';
import SignInPage from './pages/SignInPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import CreatePodcastPage from './pages/CreatePodcastPage';
import FriendsPage from './pages/FriendsPage';
import FriendRequestsPage from './pages/FriendRequestsPage';
import ExploreUsersPage from './pages/ExploreUsersPage';
import UserProfilePage from './pages/UserProfilePage';
import PodcastPage from './pages/PodcastPage';
import PodcastDetailsPage from './pages/PodcastDetailsPage';

// Component to initialize API error handlers
function ApiErrorHandler() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    initializeApiErrorHandlers(logout, navigate);
  }, [logout, navigate]);

  return null;
}

function AppContent() {
  const location = useLocation();
  
  // Hide navigation on sign-in and register pages
  const showNavigation = location.pathname !== '/signin' && location.pathname !== '/register';
  
  return (
    <div className="App">
      <ApiErrorHandler />
      {showNavigation && <Navigation />}
      <main className="main-content">
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<HomePage />} />
              <Route path="/signin" element={<SignInPage />} />
              <Route path="/register" element={<RegisterPage />} />
              
              {/* Protected routes */}
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <DashboardPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/create-podcast" 
                element={
                  <ProtectedRoute>
                    <CreatePodcastPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/friends" 
                element={
                  <ProtectedRoute>
                    <FriendsPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/friend-requests" 
                element={
                  <ProtectedRoute>
                    <FriendRequestsPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/explore-users" 
                element={
                  <ProtectedRoute>
                    <ExploreUsersPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/user/:userId" 
                element={
                  <ProtectedRoute>
                    <UserProfilePage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/podcasts" 
                element={
                  <ProtectedRoute>
                    <PodcastPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/podcast/get-podcast/:id" 
                element={
                  <ProtectedRoute>
                    <PodcastDetailsPage />
                  </ProtectedRoute>
                } 
              />
              
              {/* Catch all route */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
